export const COMPANY = {
  name: "CoreDock Logistics",
  tagline: "Your Freight, Our Priority",
  contact: "Prabh Chahal",
  phone: "+1 647-204-6323",
  phoneRaw: "+16472046323",
  email: "info@coredocklogistics.com",
  website: "www.coredocklogistics.com",
  address: "1750 Britannia Rd E",
  city: "Mississauga, ON L4W 1J3",
  hours: "Open 24 Hours",
};

export const IMAGES = {
  heroTruck: "/brand/building.png",
  building: "/brand/building.png",
  warehouse: "/brand/warehouse-dark.webp",
  warehouseDark: "/brand/warehouse-dark.webp",
  forklift: "/brand/forklift-operator.jpeg",
  facility: "/brand/warehouse.jpeg",
  loadingDocks: "/brand/building.png",
  docksBay: "/brand/building.png",
  boxTruck: "/brand/truck.png",
  trailer: "/brand/truck.png",
  containers: "/brand/warehouse.jpeg",
  pallet: "/brand/pallet.jpeg",
  forkliftDark: "/brand/forklift-dark.jpeg",
};

export const SERVICES = [
  { slug: "cross-docking", icon: "ArrowLeftRight", title: "Cross-Docking",
    short: "Unload incoming freight, sort or organize it, and transfer it to an outbound vehicle with minimal storage time.",
    long: "Unload freight from an incoming vehicle, organize or sort it, and transfer it to an outbound vehicle with minimal storage time. Ideal for keeping shipments moving through the GTA without unnecessary holding.",
    image: "docksBay" },
  { slug: "warehousing", icon: "Warehouse", title: "Short-Term Warehousing",
    short: "Secure temporary storage for freight requiring a short delay before pickup, transfer, or final delivery.",
    long: "Secure temporary storage for freight requiring a short delay before pickup, transfer, or final delivery. 24–72 hours is a common option — availability must be confirmed for your specific shipment.",
    image: "warehouse" },
  { slug: "pallet-transfers", icon: "Layers", title: "Pallet Transfers",
    short: "Transfer freight between damaged, unsuitable, or customer-required pallets.",
    long: "Transfer freight between damaged, unsuitable, or customer-required pallets so your shipment is ready for the next leg of its journey and compliant with receiver requirements.",
    image: "forklift" },
  { slug: "freight-sorting", icon: "SlidersHorizontal", title: "Freight Sorting",
    short: "Sort shipments by destination, PO, customer, route, SKU, or your supplied instructions.",
    long: "Sort shipments by destination, purchase order, customer, route, SKU, or other supplied instructions. Clear, accurate sorting keeps downstream handling fast and error-free.",
    image: "containers" },
  { slug: "rework-restacking", icon: "Boxes", title: "Rework & Pallet Restacking",
    short: "Restack unstable pallets, replace stretch wrap, apply labels, and prepare freight for transport.",
    long: "Restack unstable pallets, replace stretch wrap, apply labels, and prepare freight for continued transportation — protecting product integrity and meeting carrier standards.",
    image: "loadingDocks" },
  { slug: "pickup-delivery", icon: "Truck", title: "Local Pickup & Delivery",
    short: "Scheduled and time-sensitive commercial freight pickup and delivery across the GTA.",
    long: "Provide scheduled and time-sensitive commercial freight pickup and delivery throughout the GTA and surrounding Ontario areas.",
    image: "boxTruck" },
  { slug: "ltl-freight", icon: "PackageCheck", title: "LTL Freight Solutions",
    short: "Pickup-and-delivery support for less-than-truckload shipments, coordinated with cross-docking.",
    long: "Offer pickup-and-delivery support for less-than-truckload commercial shipments, including coordination with cross-docking and short-term storage.",
    image: "trailer" },
  { slug: "appointment-scheduling", icon: "CalendarClock", title: "Appointment Scheduling",
    short: "Coordinate warehouse, carrier, pickup, and delivery appointments to reduce delays.",
    long: "Coordinate warehouse, carrier, pickup, and delivery appointments to help reduce delays and improve communication across every party in your shipment.",
    image: "facility" },
];

export const INDUSTRIES = [
  { icon: "Truck", title: "Freight Carriers & Trucking", desc: "Reliable cross-dock and transfer support to keep your equipment turning." },
  { icon: "Network", title: "Freight Brokers & 3PL", desc: "A dependable GTA handling partner you can put behind your service promises." },
  { icon: "Factory", title: "Manufacturers", desc: "Flexible short-term storage and staging for production and outbound freight." },
  { icon: "Warehouse", title: "Distributors & Wholesalers", desc: "Sorting, restacking, and consolidation to keep distribution flowing." },
  { icon: "ShoppingCart", title: "Retail & E-commerce", desc: "Responsive handling for time-sensitive retail and online order freight." },
  { icon: "Ship", title: "Importers & Exporters", desc: "Cross-docking near Pearson Airport and Highway 401 for inbound and outbound loads." },
];

export const WHY = [
  { icon: "MapPin", title: "Convenient Mississauga Location", desc: "Central to the GTA with fast access to major routes." },
  { icon: "Timer", title: "Quick Freight Turnaround", desc: "Minimal dwell time keeps your shipments moving." },
  { icon: "Boxes", title: "Flexible Short-Term Storage", desc: "Space when you need it, for as long as you need it." },
  { icon: "ShieldCheck", title: "Professional Freight Handling", desc: "Careful, safety-focused handling on every load." },
  { icon: "Truck", title: "Local GTA Pickup & Delivery", desc: "Scheduled and urgent runs across the region." },
  { icon: "MessageSquare", title: "Responsive Communication", desc: "Clear updates from request to completion." },
  { icon: "Zap", title: "Urgent & Scheduled Shipments", desc: "Solutions built around your timeline." },
  { icon: "Plane", title: "Highway 401 & Pearson Access", desc: "Strategically located for fast connections." },
];

export const STEPS = [
  { n: "01", title: "Request a Quote", desc: "Tell us what you're moving, when it arrives, and where it needs to go." },
  { n: "02", title: "Schedule Your Freight", desc: "We confirm timing, dock availability, and any special handling." },
  { n: "03", title: "We Receive, Sort & Transfer", desc: "Freight is received, sorted, transferred, or stored as required." },
  { n: "04", title: "Prepared for Pickup or Delivery", desc: "Your freight is staged, labelled, and ready to move on." },
];

export const VALUES = [
  { icon: "ShieldCheck", title: "Reliability", desc: "We do what we say, on the timeline we commit to." },
  { icon: "MessageSquare", title: "Communication", desc: "Clear, proactive updates at every stage." },
  { icon: "HardHat", title: "Safety", desc: "A safety-focused approach to every shipment we touch." },
  { icon: "Gauge", title: "Efficiency", desc: "Lean handling that keeps freight moving." },
  { icon: "ClipboardCheck", title: "Accountability", desc: "We take ownership of your freight while it's with us." },
  { icon: "Handshake", title: "Customer Service", desc: "Responsive, practical support for carriers and shippers." },
];

export const SERVICE_AREAS = [
  "Mississauga", "Brampton", "Toronto", "Etobicoke", "Vaughan",
  "Oakville", "Milton", "Burlington", "Hamilton",
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/about", label: "About Us" },
  { to: "/service-area", label: "Service Area" },
  { to: "/contact", label: "Contact" },
];
